<div class="preloader-wrapper" [ngClass]="{'color': Color}">
  <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
</div>
